export default __webpack_public_path__ + "static/media/f3.1f125266.svg";